import React from 'react'
import { Container } from './styles'

export interface PublicProps {
  children: any
}

import Footer from '../../../components/Footer'

const Public: React.FunctionComponent<PublicProps> = ({ children }) => (
  <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <Container>{children}</Container>
    <Footer />
  </div>
)

export default Public
